/**
 * HudBadge — pastille statut/eyebrow standard.
 * tone: 'gold' | 'success' | 'warning' | 'danger' | 'info' | 'neutral'
 */
const HudBadge = ({ tone = 'neutral', icon: Icon, children, className = '', ...rest }) => {
  return (
    <span className={`hud-badge hud-badge-${tone} ${className}`} {...rest}>
      {Icon && <Icon className="w-3 h-3" strokeWidth={2} />}
      {children}
    </span>
  );
};

export default HudBadge;
export { HudBadge };
